import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgCheckSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1 8.56L5.41 13L15 3"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgCheckSmall.displayName = 'SvgCheckSmall';
const CheckSmall = withForgeIconProps(SvgCheckSmall, {
  name: 'Check',
  usage: 'Use to indicate or mark an item as completed or selected.',
  related: 'yes, done, okay, select, complete, checked',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default CheckSmall;
